import 'sweetalert2/dist/sweetalert2.min.css'
import VueSweetalert2 from 'vue-sweetalert2'

export default function (app) {
  app.use(VueSweetalert2)
}

